export const apiTokenList = [
  {
    key: "baidu7",
    apiToken:
      "TRixfpKwzuOPQtlL4f7O03mO4lRrrm17@w30YEWvRKYEGqNRppBS7lITCzpUygnA3",
  },
  {
    key: "yueke",
    apiToken:
      "0tY8XRmfG9VHZgVdZ2tgmpIzE46q3znZ@IEq8paW74P6q30zxCpRAwOArFl1NzfeZ",
  },
  {
    key: "xywl777",
    apiToken:
      "h67GNF78a6RN7GsRluBGeZxjvaQ8Hs3M@yoqOtOgyTqZdOjY3kGBWpqMhHAPsSSuu",
  },
  {
    key: "91wll",
    apiToken:
      "LSNYsZQiTgFzk5UsesdaEaVFde27qYsn@dQQ1OrMQbrk6ZObhn7SeZcXT2Poe7Eh7",
  },
  {
    IDX: 1,
    key: "u3kna453tx36oy2szkir",
    Secret: "kdou2lzvxay10b242umbds51xqxxj8cd",
  },
  {
    IDX: 1,
    key: "24qqignvasbxolvnwuse",
    Secret: "mgchiijwg7xcoa1za0s2a7ykpsm1mgi8",
  },
  {
    IDX: 1,
    key: "3ydvi7v87l8h20re9oy5",
    Secret: "4s49ksnnn04dr7afmwt6r8l7bv48rltu",
  },
];
